// 21.2.5.3 get RegExp.prototype.flags()
var $ = require('./$');
if(require('./$.descriptors') && /./g.flags != 'g')$.setDesc(RegExp.prototype, 'flags', {
  configurable: true,
  get: require('./$.flags')
});


//////////////////
// WEBPACK FOOTER
// ./~/babel-core/~/core-js/modules/es6.regexp.flags.js
// module id = 158
// module chunks = 0